/* 正则验证相关

 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

export default {
  /* 手机号 */
  mobile (num) {
    return /^1[3-9][0-9]{9}$/.test(num)
  },
  /* 座机号码 */
  phone (num) {
    return /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,8}(-\d+)?$/.test(num)
  },
  /* 邮箱 */
  email (str) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str)
  },
  /* 身份证 */
  idCard (str) {
    return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(str)
  },
  /* 整数 */
  intNum (num) {
    return /(^[0-9]*$)/.test(num)
  },
  /* 校验码 */
  checkCode (code,type) {
    let checkCodeMap =  {
      'blockChain': /^[A-Za-z0-9]{5}$/.test(code),
      'generalVAT': /^\d{6}$/.test(code) || /^\d{20}$/.test(code),
      'VAT': true
    }
    return checkCodeMap[type]
  },
  /** 是否是可访问的网址 */
  // isURL(str_url) {
  //   try {
  //     str_url = str_url.toLowerCase();
  //   } catch (error) {
  //   }

  // //   var strRegex = "^((https|http|ftp|rtsp|mms)?://)" +
  // //     "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@
  // //     +
  // //     "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
  // //     +
  // //     "|" // 允许IP和DOMAIN（域名）
  // //     +
  // //     "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
  // //     +
  // //     "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
  // //     +
  // //     "[a-z]{2,6})" // first level domain- .com or .museum
  // //     +
  // //     "(:[0-9]{1,4})?" // 端口- :80
  // //     +
  // //     "((/?)|" // a slash isn't required if there is no file name
  // //     +
  // //     "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
  // //   var re = new RegExp(strRegex);
  // //   //re.test()
  // //  return  re.test(str_url);
  // },
  /* 整数或小数 */
  intOrFloatNum (str) {
    return /^[0-9]+(\.[0-9]+)?$/.test(str)
  },
  /* 至少包含2种字符的6到16位密码 */
  password (str) {
    return /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/.test(str)
  },
  /* 5位数字验证码 */
  code (num) {
    return /^\d{5}$/.test(num)
  },

  /* 发票代码    10或12位数字或大写字母 */
  invoiceCode (num) {
    return /^[A-Z0-9]{10}$/.test(num) || /^[A-Z0-9]{12}$/.test(num)
  },

  /* 区块链发票代码    12位数字 */
  blockChainInvoiceCode (num) {
    return /^[0-9]{12}$/.test(num)
  },

  /* 发票号码  8位数字 */
  invoiceNo (num) {
    return /^\d{8}$/.test(num)
  },

  /* 发票号码  20位数字 */
  invoiceNoQ (num) {
    return /^\d{20}$/.test(num)
  },

  /* 发票代码或号码    需求5482，【发票代码、发票号码】可能是【数字、大小写英文】，且最多是25位 */
  invoiceCodeNo (str) {
    var reg = /^[a-zA-Z0-9]+$/
    if (str.length > 25 || !reg.test(str)) {
      return false
    }
    return true
  },

   /* 是否是税号--销项
  15 || 18 || 20位   数字+大写字母
  */
  outInvoiceTaxNumber (str) {
    // 15-21位    中英文
    // var reg = /^[0-9A-Z]+$/
    // if (str.length > 20 || str.length < 15 || !reg.test(str)) {
    //   return false
    // }
    // if (str.indexOf('0') == 0) {
    //   return false
    // }
    // var addressCode = str.substring(0, 6)
    // if (!reg1.test(addressCode)) {
    //   return false
    // }
    var reg1 = /^([0-9A-Z]{15}|[0-9A-Z]{18}|[0-9A-Z]{20})$/
    return !str || reg1.test(str)
  },

  /* 是否是税号
  15-21位   英文数字 大写字母IOVZ除外
  */
  taxNumber (str) {
    // 15-21位    中英文
    var reg = /^[0-9A-Z]+$/
    var reg1 = /^\d{6}$/
    if (str.length > 20 || str.length < 15 || !reg.test(str)) {
      return false
    }
    if (str.indexOf('0') == 0) {
      return false
    }
    // var addressCode = str.substring(0, 6)
    // if (!reg1.test(addressCode)) {
    //   return false
    // }
    return true
  },
  /**
   * 非企业性单位税号最小长度是6位
   * @param {*} str
   */
  taxNumber4personOrNonbusiness (str) {
    if (str == '') return true// 可以不传
    // 6-21位    中英文
    var reg = /^[0-9A-Z]+$/
    if (str.length > 21 || str.length < 6 || !reg.test(str)) {
      return false
    }
    return true
  },
  /** 验真发票抬头
   * 长度<100
   */
  invoiceTitle (str) {
    return str != null && str.length < 100
  },
  /* 是否是GUID  格式如2064d355-c0b9-41d8-9ef7-9d8b26524751 */
  guid (str) {
    return /^[A-Z0-9]{8}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{12}$/.test(str)
  },
  /** 是否是YYYYMMDD格式日期
   * 如果是则返回日期，如果不是返回空
   */
  toDateFromString (strDate) {
    if (strDate.length != 8) {
      return null
    }
    var dtDate = null
    var nYear = parseInt(strDate.substring(0, 4), 10)
    var nMonth = parseInt(strDate.substring(4, 6), 10)
    var nDay = parseInt(strDate.substring(6, 8), 10)
    if (isNaN(nYear) == true || isNaN(nMonth) == true || isNaN(nDay) == true) {
      return null
    }
    dtDate = new Date(nYear, nMonth - 1, nDay)
    if (nYear != dtDate.getFullYear() || (nMonth - 1) != dtDate.getMonth() || nDay != dtDate.getDate()) {
      return null
    }
    return dtDate
  }
}
